export default __webpack_public_path__ + "static/media/blend-graph-on2.ddff482e.svg";